import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.less']
})
export class SurveyComponent implements OnInit {

  dropdown = false;
  chart = false;
  filter = false;
  surveysOne: Array<any>;
  surveysTwo: Array<any>;
  column = 'lastName';
  isDesc = false;
  dropdownLabel = ['New Report'];
  // pageList = ['New Report','Master Summary','Analysis','Report Summary','Payments'];

  constructor(private router: Router) { }

  ngOnInit() {
    // this.pageList = [
    //   {
    //     Id: 0,
    //     name: 'New Report',
    //   },
    //   {
    //     Id: 1,
    //     name: 'Master Summary'
    //   },
    //   {
    //     Id: 2,
    //     name: 'Analysis'
    //   },
    //   {
    //     Id: 3,
    //     name: 'Report Summary'
    //   },
    //   {
    //     Id: 4,
    //     name: 'Payments'
    //   }
    // ];
    this.surveysOne = [
      {
        Id: 0,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 1,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      }
    ];

    this.surveysTwo = [
      {
        Id: 0,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 1,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 2,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 3,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 4,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      },
      {
        Id: 5,
        lastName: 'Galagher',
        firstName: 'Noel',
        location: 'London',
      }
    ];
  }

  sort(survey) {
    this.isDesc = !this.isDesc;
    this.column = survey;
    const direction = this.isDesc ? 1 : -1;

    this.surveysOne.sort(function (a, b) {
      if (a[survey] < b[survey]) {
        return -1 * direction;
      }
      else if (a[survey] > b[survey]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  sortTwo(test) {
    this.isDesc = !this.isDesc;
    this.column = test;
    const direction = this.isDesc ? 1 : -1;

    this.surveysTwo.sort(function (a, b) {
      if (a[test] < b[test]) {
        return -1 * direction;
      }
      else if (a[test] > b[test]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  showChart() {
    this.chart = true;
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  changeLabel(s) {
    this.dropdownLabel = s;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/survey/survey.component.ts